import React from "react";
import { useCopies } from "shared/hooks/useCopies";

export default function ColumnHeaderWithTimezone(props: { label: React.ReactNode; timeZone?: string }) {
  const copies = useCopies();
  return (
    <React.Fragment>
      {props.label}{" "}
      {props.timeZone && (
        <span className="thead_column_timezone" title={copies.get("timezone")}>
          ({props.timeZone})
        </span>
      )}
    </React.Fragment>
  );
}
